const e="https://dovemed-prod-k8s.s3.amazonaws.com/media/images/General.format-webp.width-750.webp";export{e as DOVEMED_DEFAULT_PICTURE};
